import { render, staticRenderFns } from "./vAddonProducts.vue?vue&type=template&id=3722b64b&"
import script from "./vAddonProducts.vue?vue&type=script&lang=js&"
export * from "./vAddonProducts.vue?vue&type=script&lang=js&"
import style0 from "./vAddonProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports